<template>
  <small>
    <strong>{{ counter }}</strong> {{ $root.plural(counter, 'application.charcounter.remaining', zero()) }}
  </small>
</template>

<script>
  export default {
    name: 'char-counter',
    props: ['value', 'max'],
    computed: {
      counter () {
        if (!this.value) {
          return this.max
        }
        return this.max - this.value.toString().length
      }
    },
    methods: {
      zero () {
        return {
          zero: 'application.charcounter.remaining.singular'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CharCounter.vue?023218ef